import React, { FC } from 'react';
import { Grid, Skeleton, Typography } from '@mui/material';
import styles from './SkeletonComponent.module.scss';

interface SkeletonComponentProps {
    variant: 'headerAndContentHalfHalfLayout';
}

const SkeletonComponent: FC<SkeletonComponentProps> = (props) => {
    const { variant } = props;

    if (variant === 'headerAndContentHalfHalfLayout') {
        return (
            <Grid
                className={styles.SkeletonComponent}
                data-testid="SkeletonComponent"
                container
                spacing={2}
                sx={{ width: '100%' }}
            >
                <Grid size={{ xs: 12, md: 6 }}>
                    <Typography variant="h1"><Skeleton sx={{ width: '50%' }} /></Typography>
                    <Skeleton variant="rectangular" width="100%" height={650} />
                </Grid>
                <Grid size={{ xs: 12, md: 6 }}>
                    <Typography variant="h1"><Skeleton sx={{ width: '50%' }} /></Typography>
                    <Skeleton variant="rectangular" width="100%" height={650} />
                </Grid>
            </Grid>
        );
    }

    return null;
};

export default SkeletonComponent;
